var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{attrs:{"type":"simple","header":_vm.header,"footer":_vm.pageFooter}},[_c('error-box',{attrs:{"error":_vm.error}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }